import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from "react-bootstrap";
import { secondsToTime } from "../../utilities/scoringUtilities";
import { MatchEvents } from "../../models/enums/MatchEvents";
import { PenaltyOutcome } from "../../models/enums/PenaltyOutcome";
import { PenaltyReason } from "../../models/enums/PenaltyReason";
import { LineoutTarget } from "../../models/enums/LineoutTarget";
import { FreekickOutcome } from "../../models/enums/FreekickOutcome";
import scoringService from "../../services/ScoringService";

import { v4 as uuidv4 } from "uuid";

const LineOutInfoUpdate = (props) => {
  const {
    onCancelClipButtonClick,
    isWon,
    setIsWon,
    lineoutTarget,
    setLineoutTarget,
    isFreekick,
    setIsFreekick,
    realMarkerX, 
    realMarkerY, 
    clipSelected, 
    setClip
  } = props;

  const [freekickSelected, setFreekickSelected] = useState(null);
  
  const handleWonOrLostStatus = async (isWonOrLost) => {
    await setIsWon(isWonOrLost);
  };

  const handleTargetToggle = (target) => {
    setLineoutTarget(target);
  };

  const isTargetActive = (targetStatus) => {
    return targetResult === targetStatus;
  };

  const handleFreekickStatus = async(status) => {
    if (freekickSelected === true || !clipSelected.freekickResult || clipSelected.freekickResult !== status) {
      await setIsFreekick((prevState) => (prevState === status ? null : status));
    }
    else
    {
      await setIsFreekick(null);
    }
    await setFreekickSelected(true);
  };

  let markerX = realMarkerX != null ? realMarkerX : clipSelected.positionX;
  let markerY = realMarkerY != null ? realMarkerY : clipSelected.positionY;
  let wonOrLost = isWon !== null ? isWon : clipSelected.matchEventWon;
  let targetResult = lineoutTarget ? lineoutTarget : clipSelected.lineoutTargetResult;
  let freekick = freekickSelected ? isFreekick : clipSelected.freekickResult;

  return (
    <>
      <div className="d-flex flex-fill justify-content-end align-items-end">
        <Button
          className="ml-1"
          variant="outline-primary"
          size="md"
          disabled = {wonOrLost !== null && targetResult != null ? false : true}
          onClick={async (e) => {
             setClip(clipSelected.id, markerX, markerY, clipSelected.type, clipSelected.teamId, clipSelected.shirtNumber, wonOrLost, targetResult, freekick);
             setFreekickSelected(false);
          }}
        >
          Confirm Update Lineout
        </Button>
        <Button
          className="ml-1"
          variant="outline-danger"
          size="md"
          onClick={async (e) => {
             onCancelClipButtonClick();
             setFreekickSelected(false);

          }}
        >
          Cancel
        </Button>
      </div>
      <div className="col-md-12 text-center">
        <Row style={{ marginTop: "4rem" }}>
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-2.5rem"}}>
          <h5>Outcome</h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: wonOrLost ? "#70747c" : "",
                  color: wonOrLost ? "white" : "",
                }}
                onClick={async() => await handleWonOrLostStatus(true)}
              >
                WON
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: wonOrLost === false? "#70747c" : "",
                  color: wonOrLost === false ? "white" : "",
                }}
                onClick={async() => await handleWonOrLostStatus(false)}
              >
                LOST
              </Button>
            </div>
          </Col>
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-2.5rem"}}>
          <h5>Target</h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Front)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Front) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Front)}
              >
                FRONT
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Middle)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Middle) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Middle)}
              >
                MIDDLE
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Back)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Back) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Back)}
              >
                BACK
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Midfield)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Midfield) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Midfield)}
              >
                MIDFIELD
              </Button>
            </div>
          </Col>
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-1rem"}}>
            <h5></h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                    freekick === FreekickOutcome.FreeKickFor ? "#70747c" : "",
                  color:
                    freekick === FreekickOutcome.FreeKickFor ? "white" : "",
                }}
                onClick={() =>
                  handleFreekickStatus(FreekickOutcome.FreeKickFor)
                }
              >
                FREE KICK FOR
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                    freekick === FreekickOutcome.FreeKickAgainst
                      ? "#70747c"
                      : "",
                  color:
                    freekick === FreekickOutcome.FreeKickAgainst
                      ? "white"
                      : "",
                }}
                onClick={() =>
                  handleFreekickStatus(FreekickOutcome.FreeKickAgainst)
                }
              >
                FREE KICK AGAINST
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      </>
  );
};

export default LineOutInfoUpdate;
